import type { EndpointConfig } from '../types'

// Gateway endpoint constants
export const GatewayEndpoints = {
  // Assets
  ASSETS_GET_ALL: 'get-assets-by-asset-type-id',
  ASSETS_GET_BY_ID: 'get-asset-by-id',
  ASSETS_GET_FILTERED: 'get-filtered-assets',
  ASSETS_GET_FILTERED_DISTRIBUTION: 'get-filtered-assets-distribution',
  ASSETS_GET_FILTERED_IDS: 'get-filtered-asset-ids',
  ASSETS_GET_MAP_FEATURES: 'get-map-feature-by-geohash',
  ASSETS_GET_NETWORK_STATUSES: 'get-assets-network-statuses',
  ASSETS_CREATE: 'create-asset',
  ASSETS_UPDATE: 'update-asset',
  ASSETS_DELETE: 'delete-asset',
  GROUPED_ASSET_COUNT: 'get-assets-count',
  ASSETS_ASSIGN_GROUPS: 'post-association-group-asset',
  ASSETS_UPDATE_CUSTOM_FIELD: 'update-asset-custom-field',
  REFRESH_LATEST_LOG: 'refresh-latest-log',

  // Actions
  ACTIONS_GET_ALL: 'get-all-actions',
  GET_ACTION_BY_ID: 'get-action-by-id',
  GET_ACTION_ASSETS_BY_ID: 'get-action-assets-by-action-id',
  CANCEL_ACTION: 'cancel-action',
  RETRY_ACTION: 'retry-action',
  CANCEL_ASSET_ACTION: 'cancel-asset-action',
  RETRY_ASSET_ACTION: 'retry-asset-action',

  // Capabilities
  ASSETS_ACTIONS_GET_BY_ASSET_IDS: 'get-assets-actions-by-asset-ids',
  ASSETS_ACTIONS_POST: 'post-asset-action',
  STATES_AND_TELEMETRY: 'get-all-states-telemetry-and-custom-fields',

  // Alert Rules
  ALERT_RULES_GET_ALL: 'get-all-alert-rules',
  ALERT_RULES_GET_BY_ID: 'get-alert-rule-by-id',
  ALERT_RULES_CREATE: 'create-alert-rule',
  ALERT_RULES_UPDATE: 'update-alert-rule',
  ALERT_RULES_DELETE: 'delete-alert-rule',
  ALERTS_GET_BY_RULE_ID: 'get-alerts-by-alert-rule-id',
  ALERTS_DISMISS_BY_ID: 'resolve-alert-by-id',

  // Configured Assets
  CONFIGURED_ASSETS_GET_ALL: 'get-all-configured-assets',

  // Asset Types
  ASSET_TYPES_GET_ALL: 'get-asset-type-ids',
  GET_ASSET_TYPE_CUSTOM_FIELDS: 'get-asset-type-custom-fields',

  // Licenses
  LICENSES_GET_ALL: 'get-all-licences-for-user',

  // Permissions
  PERMISSIONS_GET: 'get-user-permissions',
  AUTH_SITE_REACH_GET: 'get-user-site-reach',

  // Localization
  LOCALIZATIONS_GET_ALL: 'get-all-localizations',
  LOCALIZATIONS_CREATE: 'create-localizations',
  LOCALIZATIONS_GET_BY_KEY: 'get-localizations-by-key',
  LOCALIZATIONS_GET_BY_LANG: 'get-localizations-by-lang',
  LOCALIZATIONS_DELETE: 'delete-localizations',
  LOCALIZATIONS_UPDATE: 'update-localizations',

  //Map Icon Config
  GET_MAP_ICON_CONFIGS: 'get-all-map-icons-configs',
  GET_MAP_ICON_COLORS: 'get-all-map-icons-colors',
  GET_ALERT_LEVEL_COLORS: 'get-map-alert-level-colors',

  // Locations
  SITES_GET_ALL: 'get-all-sites',
  SITE_GET_BY_ID: 'get-site-by-id',
  SITE_CREATE: 'create-site',
  SITE_UPDATE: 'update-site',
  SITE_DELETE: 'delete-site',
  ZONES_GET_BY_SITE_ID: 'get-site-zones',

  // Routes / Segments / Sections
  ROUTES_GET_ALL: 'get-all-routes',
  ROUTES_GET_HIERARCHY: 'get-all-routes-hierarchy',
  ZONES_GET_GEO_POLYLINES: 'get-zone-geopolylines',

  // Groups
  GROUPS_GET_ALL: 'get-all-groups',
  GROUPS_CREATE: 'create-group',
  GROUPS_UPDATE: 'update-group',
  GROUPS_DELETE: 'delete-group',
  GROUPS_ASSIGN_ASSETS: 'associate-group-with-assets',
  GROUPS_UNASSIGN_ASSETS: 'deassociate-assets-from-group',
  GROUPS_GET_ASSETS: 'list-group-assets',
  GROUPS_GET_DETAILS: 'get-group-details',

  // Behaviours
  BEHAVIOURS_CREATE: 'create-behaviour',
  BEHAVIOURS_REMOVE_SCHEDULE: 'remove-behaviour-schedule',
  BEHAVIOURS_REMOVE_PRESET: 'remove-behaviour-preset',

  // Configuration presets
  CONFIGURATION_PRESETS_GET_ALL: 'get-configuration-presets',
  CONFIGURATION_PRESETS_CREATE: 'create-configuration-preset',
  CONFIGURATION_PRESETS_UPDATE: 'update-configuration-preset',
  CONFIGURATION_PRESETS_DELETE: 'delete-configuration-preset',
  GROUPS_GET_PRESET_STATUS: 'get-group-preset-status',
  GROUPS_SYNC_PRESETS: 'sync-group-presets',
  ASSETS_SYNC_PRESETS: 'sync-asset-presets',

  // Filters
  FILTERS_GET_ALL: 'get-all-filters',
  FILTERS_GET_BY_ID: 'get-filter-by-id',
  FILTERS_CREATE: 'create-filter',
  FILTERS_UPDATE: 'update-filter',
  FILTERS_DELETE: 'delete-filter',

  // Schedules
  SCHEDULES_GET_ALL: 'get-all-schedules',
  SCHEDULES_GET_BY_MONTH: 'get-schedules-by-month',
  SCHEDULES_GET_BY_ID: 'get-schedule-by-id',
  SCHEDULES_CREATE: 'create-schedule',
  SCHEDULES_UPDATE: 'update-schedule',
  SCHEDULES_DELETE: 'delete-schedule',
  SCHEDULE_EVENTS_GET_BY_SCHEDULE_ID: 'get-schedule-events-by-schedule-id',
  SCHEDULE_EVENTS_GET_BY_MONTH: 'get-schedule-event-by-month',
  SCHEDULE_EVENTS_GET_BY_ID: 'get-schedule-event-by-id',
  SCHEDULE_EVENTS_CREATE: 'create-schedule-event',
  SCHEDULE_EVENTS_UPDATE: 'update-schedule-event',
  SCHEDULE_EVENTS_DELETE: 'delete-schedule-event',
  SCHEDULES_GET_ASSETS_BY_ID: 'get-schedule-assets-by-schedule-id',
  SCHEDULES_GET_CAPABILITIES_BY_ID: 'get-schedule-capabilities-by-schedule-id',
  SCHEDULES_RETRY_FAILED: 'retry-failed-schedule',
  SCHEDULES_REMOVE_ASSET: 'remove-asset-from-schedule',

  // Reports
  REPORTS_GENERATE: 'post-generate-report',

  // Users
  GET_ALL_USERS: 'get-all-user-for-licence',

  // Licence Users Management
  LICENCE_USERS_GET_DETAILS: 'get-licence-users-details',
  LICENCE_USERS_GET_ROLES: 'get-licence-roles',
  LICENCE_USERS_CREATE_INVITATION: 'create-licence-user-invitation',
  LICENCE_USERS_UPDATE_ROLES: 'update-licence-user-roles',
  LICENCE_USERS_UPDATE_INVITATION: 'update-licence-user-invitation',

  // Beacon - Used for telemetry and analytics
  BEACON_POST: 'beacon-post',

  // User Activity
  USER_ACTIVITY_POST: 'user-activity-post',

  // Plugins
  PLUGINS_GET_ALL: 'get-all-plugins',
  PLUGIN_UI_TOKEN_POST: 'plugin-ui-token-post',

  // State View Configs
  STATE_VIEW_CONFIGS_GET: 'get-state-view-configs'
} as const

type EndpointKey = keyof typeof GatewayEndpoints
type EndpointId = (typeof GatewayEndpoints)[EndpointKey]

// Gateway endpoint configuration
export const gatewayEndpointsConfig: Record<EndpointId, EndpointConfig> = {
  // Assets
  'get-assets-by-asset-type-id': {
    method: 'GET',
    path: '/assets/assets_types',
    description: 'Get all assets. Optionally filter by type, zone, etc.'
  },
  'get-asset-by-id': {
    method: 'GET',
    path: '/assets/:id',
    description: 'Get a single asset by id'
  },
  'get-filtered-assets': {
    method: 'POST',
    path: '/assets/filtered',
    description: 'Get many assets for a specific filter'
  },
  'get-filtered-assets-distribution': {
    method: 'POST',
    path: '/assets/filtered/distribution',
    description: 'Get the asset type and alert distribution for assets returned by a specific filter'
  },
  'get-assets-network-statuses': {
    method: 'POST',
    path: '/assets/statuses/filtered',
    description: 'Get the network status of all assets'
  },
  'get-filtered-asset-ids': {
    method: 'POST',
    path: '/assets/filtered/ids',
    description: 'Get many assets ids for a specific filter'
  },
  'get-map-feature-by-geohash': {
    method: 'GET',
    path: '/assets/map-features',
    description: 'Get features optimized for mapbox'
  },
  'create-asset': {
    method: 'POST',
    path: '/assets',
    description: 'Create a new asset'
  },
  'update-asset': {
    method: 'PUT',
    path: '/assets/:id',
    description: 'Update an existing asset'
  },
  'delete-asset': {
    method: 'DELETE',
    path: '/assets/:id',
    description: 'Delete an existing asset'
  },
  'get-assets-count': {
    method: 'GET',
    path: '/assets/count',
    description: 'Return the count of assets grouped by a specific field'
  },
  'post-association-group-asset': {
    method: 'POST',
    path: '/assets/:id/groups',
    description: 'Associate an asset with one or multiple groups'
  },
  'update-asset-custom-field': {
    method: 'PUT',
    path: '/assets/:asset_id/custom_fields/:custom_field_id',
    description: 'Update a custom field value for a specific asset'
  },
  'refresh-latest-log': {
    method: 'GET',
    path: '/assets/:id/refresh-latest-log',
    description: 'Get the latest log for an asset'
  },

  // Capabilities
  'get-assets-actions-by-asset-ids': {
    method: 'POST',
    path: '/assets/capabilities/actions',
    description: 'Get all actions for a list of assets'
  },
  'post-asset-action': {
    method: 'POST',
    path: '/assets/actions/:action_id',
    description: 'Invoke an action on an asset'
  },

  'get-all-states-telemetry-and-custom-fields': {
    method: 'GET',
    path: '/asset_types/states',
    description: 'Get all states, telemetries and Custom Fields for all configured asset types'
  },

  'get-all-alert-rules': {
    method: 'GET',
    path: '/alert_rules',
    description: 'Get all alert rules'
  },
  'get-alert-rule-by-id': {
    method: 'GET',
    path: '/alert_rules/:id',
    description: 'Get a specific alert rule by id'
  },
  'create-alert-rule': {
    method: 'POST',
    path: '/alert_rules',
    description: 'Create a new alert rule'
  },
  'update-alert-rule': {
    method: 'PUT',
    path: '/alert_rules/:id',
    description: 'Update an existing alert rule'
  },
  'delete-alert-rule': {
    method: 'DELETE',
    path: '/alert_rules/:id',
    description: 'Delete an existing alert rule'
  },
  'get-alerts-by-alert-rule-id': {
    method: 'GET',
    path: '/alert_rules/:id/alerts',
    description: 'Get all alerts for a specific alert rule'
  },
  'resolve-alert-by-id': {
    method: 'POST',
    path: '/alerts/:id/resolve',
    description: 'Resolve a specific alert by its unique identifier'
  },

  // Configured Assets
  'get-all-configured-assets': {
    method: 'GET',
    path: '/configured_assets',
    description: 'Get all configured asset types'
  },

  // Asset Types
  'get-asset-type-ids': {
    method: 'GET',
    path: '/asset_types',
    description: 'Get all available asset type ids optimized for map'
  },
  'get-asset-type-custom-fields': {
    method: 'GET',
    path: '/asset_types/:asset_type_id/custom_fields',
    description: 'Get all custom fields for a specific asset type'
  },

  // Licenses
  'get-all-licences-for-user': {
    method: 'GET',
    path: '/licences',
    description: 'Get all licenses for the current user. Must be authenticated.'
  },

  // Permissions
  'get-user-permissions': {
    method: 'GET',
    path: '/auth/permissions',
    description: 'Get user permissions for the current license. Must be authenticated and have an active license.'
  },
  'get-user-site-reach': {
    method: 'GET',
    path: '/auth/site-reach',
    description: 'Get the sites the user can reach in the current license and whether site scoping is enabled.'
  },

  // Localizations
  'get-all-localizations': {
    method: 'GET',
    path: '/localizations',
    description: 'Get all the user-provided translations for all keys in all languages'
  },
  'create-localizations': {
    method: 'POST',
    path: '/localizations',
    description: 'Create translation labels for a specific key'
  },
  'get-localizations-by-key': {
    method: 'GET',
    path: '/localizations/by_key/:name_localized_key',
    description: 'Get translations in all languages for a specific translation key'
  },
  'get-localizations-by-lang': {
    method: 'GET',
    path: '/localizations/by_lang/:iso_lang_code',
    description: 'Get translations for all keys in the provided language'
  },
  'delete-localizations': {
    method: 'DELETE',
    path: '/localizations/:name_localized_key',
    description: 'Delete translations for a specific key'
  },
  'update-localizations': {
    method: 'PUT',
    path: '/localizations/:name_localized_key',
    description: 'Update translations for a specific key'
  },

  // Map Icon Config
  'get-all-map-icons-configs': {
    method: 'GET',
    path: '/map-icon-configs',
    description: 'Load all map icon configs for a specific licence'
  },
  'get-all-map-icons-colors': {
    method: 'GET',
    path: '/map-icon-configs/colors',
    description: 'Load all map icon colors for a specific licence'
  },
  'get-map-alert-level-colors': {
    method: 'GET',
    path: '/map/alert-level-colors',
    description: 'Get the effective alert severity level to color mapping for the current licence'
  },

  // Locations
  'get-all-sites': {
    method: 'GET',
    path: '/locations/sites',
    description: 'Load all sites for a specific licence'
  },
  'get-site-by-id': {
    method: 'GET',
    path: '/locations/sites/:siteId',
    description: 'Load a single site by id'
  },
  'create-site': {
    method: 'POST',
    path: '/locations/sites',
    description: 'Create a new site'
  },
  'update-site': {
    method: 'PUT',
    path: '/locations/sites/:siteId',
    description: 'Update an existing site'
  },
  'delete-site': {
    method: 'DELETE',
    path: '/locations/sites/:siteId',
    description: 'Delete an existing site'
  },
  'get-site-zones': {
    method: 'GET',
    path: '/locations/sites/:siteId/zones',
    description: 'Load all sites for a specific licence'
  },

  // Routes / Segments / Sections
  'get-all-routes': {
    method: 'GET',
    path: '/locations/routes',
    description: 'Load all routes (segments and sections included) for a specific licence'
  },
  'get-all-routes-hierarchy': {
    method: 'GET',
    path: '/locations/routes/hierarchy',
    description: 'Load all routes (only routes) with their associated assets'
  },
  'get-zone-geopolylines': {
    method: 'GET',
    path: '/locations/zones/geopolylines',
    description: 'Load the GIS display lines of the given zone ids (max 500 per call)'
  },

  // Groups
  'get-all-groups': {
    method: 'GET',
    path: '/groups',
    description: 'Load groups for a specific licence, with optional name search and pagination'
  },
  'create-group': {
    method: 'POST',
    path: '/groups',
    description: 'Create a group'
  },
  'update-group': {
    method: 'PUT',
    path: '/groups/:id',
    description: 'Update a group'
  },
  'delete-group': {
    method: 'DELETE',
    path: '/groups/:id',
    description: 'Delete a group'
  },
  'associate-group-with-assets': {
    method: 'POST',
    path: '/groups/:id/assets',
    description: 'Assign multiple assets to a group'
  },
  'deassociate-assets-from-group': {
    method: 'DELETE',
    path: '/groups/:id/assets',
    description: 'Unassign multiple assets from a group'
  },
  'list-group-assets': {
    method: 'GET',
    path: '/groups/:id/assets',
    description: 'Get a paginated list of assets assigned to a specific group'
  },
  'get-group-details': {
    method: 'GET',
    path: '/groups/:id/details',
    description: "Get a group's details (name + schedules per asset type)"
  },

  // Behaviours
  'create-behaviour': {
    method: 'POST',
    path: '/behaviour',
    description: 'Associate a schedule to a target (group) for one asset type'
  },
  'remove-behaviour-schedule': {
    method: 'DELETE',
    path: '/behaviour/:id/schedule',
    description: 'Dissociate the schedule from its target, the configuration preset is kept'
  },
  'remove-behaviour-preset': {
    method: 'DELETE',
    path: '/behaviour/:id/preset',
    description: 'Remove the configuration preset carried by a behaviour, the schedule is kept'
  },

  // Configuration presets
  'get-configuration-presets': {
    method: 'GET',
    path: '/configuration-presets',
    description: 'List the configuration presets of the licence, optionally for one asset type'
  },
  'create-configuration-preset': {
    method: 'POST',
    path: '/configuration-presets',
    description: 'Create a configuration preset for one asset type'
  },
  'update-configuration-preset': {
    method: 'PUT',
    path: '/configuration-presets/:id',
    description: 'Update the name and values of a configuration preset'
  },
  'delete-configuration-preset': {
    method: 'DELETE',
    path: '/configuration-presets/:id',
    description: 'Delete a configuration preset that no group uses'
  },
  'get-group-preset-status': {
    method: 'GET',
    path: '/groups/:id/configuration-presets/status',
    description: 'Synced / in sync / out of sync asset counters per asset type of a group'
  },
  'sync-group-presets': {
    method: 'POST',
    path: '/groups/:id/configuration-presets/sync',
    description: 'Push the group preset of one asset type to the assets that drift from it'
  },
  'sync-asset-presets': {
    method: 'POST',
    path: '/assets/:id/configuration-presets/sync',
    description: 'Push the governing preset to one asset, optionally restricted to some configuration blocks'
  },

  // Filters
  'get-all-filters': {
    method: 'GET',
    path: '/filters',
    description: 'Load all filters for a specific licence'
  },
  'get-filter-by-id': {
    method: 'GET',
    path: '/filters/:id',
    description: 'Load a specific filter'
  },
  'create-filter': {
    method: 'POST',
    path: '/filters',
    description: 'Create a filter'
  },
  'update-filter': {
    method: 'PUT',
    path: '/filters/:id',
    description: 'Update a filter'
  },
  'delete-filter': {
    method: 'DELETE',
    path: '/filters/:id',
    description: 'Delete a filter'
  },

  // Actions
  'get-action-by-id': {
    method: 'GET',
    path: '/actions/:id',
    description: 'Get action by id'
  },
  'get-all-actions': {
    method: 'GET',
    path: '/actions',
    description: 'Get all actions'
  },
  'get-action-assets-by-action-id': {
    method: 'GET',
    path: '/actions/:id/assets',
    description: 'Get specific action assets list'
  },
  'cancel-action': {
    method: 'POST',
    path: '/actions/:actionId/cancel',
    description: 'Cancel a specific action by id'
  },
  'retry-action': {
    method: 'POST',
    path: '/actions/:actionId/retry',
    description: 'Retry a specific action by id'
  },
  'cancel-asset-action': {
    method: 'POST',
    path: '/assets/:assetId/actions/:actionId/cancel',
    description: 'Cancel a specific action by id'
  },
  'retry-asset-action': {
    method: 'POST',
    path: '/assets/:assetId/actions/:actionId/retry',
    description: 'Retry a specific action by id'
  },

  // Schedules
  'get-all-schedules': {
    method: 'GET',
    path: '/schedules',
    description: 'Get all schedules using a paginator'
  },
  'get-schedules-by-month': {
    method: 'GET',
    path: '/schedules/filtered',
    description: 'Get schedules by month'
  },
  'get-schedule-by-id': {
    method: 'GET',
    path: '/schedules/:id',
    description: 'Get a schedule by id'
  },
  'create-schedule': {
    method: 'POST',
    path: '/schedules',
    description: 'Create a new schedule'
  },
  'update-schedule': {
    method: 'PUT',
    path: '/schedules/:id',
    description: 'Update an existing schedule'
  },
  'delete-schedule': {
    method: 'DELETE',
    path: '/schedules/:id',
    description: 'Delete an existing schedule'
  },
  'get-schedule-assets-by-schedule-id': {
    method: 'GET',
    path: '/schedules/:scheduleId/assets',
    description: 'Get all asset ids assigned to a specific schedule'
  },
  'get-schedule-capabilities-by-schedule-id': {
    method: 'GET',
    path: '/schedules/:scheduleId/capabilities',
    description: 'Get all capabilities available for a specific schedule'
  },
  'retry-failed-schedule': {
    method: 'POST',
    path: '/schedules/:id/retry-failed',
    description: 'Retry failed assets for a specific schedule'
  },
  'remove-asset-from-schedule': {
    method: 'DELETE',
    path: '/schedules/:scheduleId/assets/:assetId',
    description: 'Remove an asset from a specific schedule'
  },
  // Schedule Events
  'get-schedule-events-by-schedule-id': {
    method: 'GET',
    path: '/schedules/:scheduleId/events',
    description: 'Returns a paginated events list from a specific schedule'
  },
  'get-schedule-event-by-month': {
    method: 'GET',
    path: '/schedules/events/:year/:month',
    description: 'Returns all events from all schedules for a specific year and month'
  },
  'get-schedule-event-by-id': {
    method: 'GET',
    path: '/schedules/:scheduleId/events/:eventId',
    description: 'Get a schedule event by id with schedule and commands'
  },
  'create-schedule-event': {
    method: 'POST',
    path: '/schedules/:scheduleId/events',
    description: 'Create a schedule event'
  },
  'update-schedule-event': {
    method: 'PUT',
    path: '/schedules/:scheduleId/events/:eventId',
    description: 'Update an existing schedule event'
  },
  'delete-schedule-event': {
    method: 'DELETE',
    path: '/schedules/:scheduleId/events/:eventId',
    description: 'Delete an existing schedule'
  },

  // Reports
  'post-generate-report': {
    method: 'POST',
    path: '/reports/:namespace/:type',
    description: 'Generate a report of a specific type'
  },

  // Users
  'get-all-user-for-licence': {
    method: 'GET',
    path: '/licences/users',
    description: 'Returns a list of all user for current license'
  },

  // Licence Users Management
  'get-licence-users-details': {
    method: 'GET',
    path: '/licences/users/details',
    description: 'Get all users with their roles and invitation status for the current licence'
  },
  'get-licence-roles': {
    method: 'GET',
    path: '/roles',
    description: 'Get all available roles for the current licence'
  },
  'create-licence-user-invitation': {
    method: 'POST',
    path: '/licences/users',
    description: 'Send an invitation to a new user to join the licence'
  },
  'update-licence-user-roles': {
    method: 'PUT',
    path: '/licences/users/:userId/roles',
    description: 'Update the roles assigned to a user. Pass empty array to remove user.'
  },
  'update-licence-user-invitation': {
    method: 'PUT',
    path: '/licences/users/:invitationId',
    description: 'Update a pending invitation'
  },

  // Beacon - Used for telemetry and analytics
  'beacon-post': {
    method: 'POST',
    path: '/beacon',
    description: 'Endpoint to receive beacon data for telemetry and analytics'
  },

  // User Activity
  'user-activity-post': {
    method: 'POST',
    path: '/user-activity',
    description: 'Endpoint to receive user activity tracking events'
  },

  // Plugins
  'get-all-plugins': {
    method: 'GET',
    path: '/api/plugins',
    description: 'List all active registered plugins with their metadata'
  },

  'plugin-ui-token-post': {
    method: 'POST',
    path: '/api/plugins/:pluginId/ui-token',
    description: 'Mint a single-use short-lived ui_token for iframe authentication'
  },

  // State View Configs
  'get-state-view-configs': {
    method: 'GET',
    path: '/state_view_configs/:view_key',
    description: 'Get the state view config for a specific view key and asset type'
  }
}
